import React from "react";
import { useSelector } from "react-redux";
//console.log("src/components/Footer.js");

function showCurrentYear() {
  return new Date().getFullYear();
}

const Footer = () => {
  const init = useSelector((state) => state.init);
  return (
    <section className="footer">
      {/* calc footer */}
      <footer>
        <hr />
        <h4>{init.c1}</h4>
        {init.c3}
        <br />
        {init.c4}
        <br />
        {init.c5}
        <br />
        <hr />
        <div className="footer-total">
          <h5>Powered by - webtoolkits - {showCurrentYear()}</h5>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
